<template>
  <div class="file-upload">
    <input class="col-sm-12" type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
  </div>
</template>
<script>
import { HTTPAUTH } from '../lib/httplib';
  export default {
		props: ['config'],
		data() {
			return {
				file: ''
			}
	},
  methods: {
    handleFileUpload(){
			this.file = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('domain', 'file');
      HTTPAUTH.post(this.config.url,
        formData,
        {
        headers: this.config.headers,
      }).then((resp) => {
				this.$emit('success', resp.data)
      }).catch((eres) => {
				this.$emit('error', eres)
      });

    },
		submitFile(){
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('domain', 'file');
      HTTPAUTH.post(this.config.url,
        formData,
        {
        headers: this.config.headers,
      }).then((resp) => {
				this.$emit('success', resp.data)
      }).catch((eres) => {
				this.$emit('error', eres)
      });
    },
  }
  }
</script>
<style>
	.file-upload {
		border: 1px solid #aaaaaa;
		padding: 5px 0;
		border-radius: 4px;
		margin-left: 5px;
	}

	.pull-right {
		float: right;
	}
</style>